module.exports = __webpack_public_path__ + "img/logo2.2fc9df88.png";